import moment from "moment";
import { ESessionType } from "./type";

export const FILE_SIZE_UNIT = 1024 * 1024;

export const SUPPORTED_IMAGE_TYPE = [
  "png",
  "jpg",
  "jpeg",
  // "apng",
  // "avif",
  // "gif",
  // "svg",
  // "webp",
];

export const MOE_SUPPORTED_FILE_TYPE = [...SUPPORTED_IMAGE_TYPE, "xls", "xlsx"];

export const MAX_UPLOAD_FILE_SIZE = 10 * FILE_SIZE_UNIT;

export const MAX_UPLOAD_FILE_NUMBER = 10;

export const MAX_IMAGE_PX = 6000;

export const MIN_IMAGE_PX = 224;

/**************************** 通用对话 ****************************/
// 文件格式
export const CHAT_SUPPORTED_FILE_TYPE = ["pdf", "txt", "doc", "docx"];
// 文件数量
export const CHAT_MAX_UPLOAD_FILE_NUMBER = 1;
// 文件大小，单位MB
export const CHAT_MAX_UPLOAD_FILE_SIZE = 2;

export const FILE_PARSE_ERROR_MSG: { [pro: number]: string } = {
  1001: "参数错误",
  1002: "服务器异常，请稍后重试",
  1003: "服务器异常，请稍后重试",

  1004: "服务器异常，请稍后重试",

  1005: "文件无法解析，请换个文件试试吧",
  1006: "没有权限",
  1007: "服务器异常，请稍后重试",
  1008: "文件件id不存在",
  1009: "文件已过期，无法继续提问",
  1010: "文件件不能超过2M",
  1011: "文件内容过长，无法使用",
};

export const SESSION_PAGE_SIZE = 30;

export const SESSION_TYPE_ORDER = [
  ESessionType.top,
  ESessionType.today,
  ESessionType.week,
  ESessionType.month,
  ESessionType.year,
  ESessionType.earlier,
];

export const SESSION_TYPE_MAP = {
  [ESessionType.top]: "置顶",
  [ESessionType.today]: "今天",
  [ESessionType.week]: "本周",
  [ESessionType.month]: "本月",
  [ESessionType.year]: "本年",
  [ESessionType.earlier]: "更早",
};

export const getTypeByTime = (time: string): ESessionType => {
  const date = moment(time);
  if (!time || !date.isValid()) {
    return ESessionType.today;
  }
  const startOfToday = moment().startOf("day");
  const startOfWeek = moment().startOf("week");
  const startOfMonth = moment().startOf("month");
  const startOfYear = moment().startOf("year");

  if (date.isSame(startOfToday, "day")) {
    return ESessionType.today;
  } else if (date.isSameOrAfter(startOfWeek)) {
    return ESessionType.week;
  } else if (date.isSameOrAfter(startOfMonth)) {
    return ESessionType.month;
  } else if (date.isSameOrAfter(startOfYear)) {
    return ESessionType.year;
  } else {
    return ESessionType.earlier;
  }
};
